export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Editar empaques en contenedor ", _interpolate(_named("container_code"))])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])},
          "add_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agregar"])},
          "update_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actualizar"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver al contenedor"])}
        }
      },
      "en": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit packages"])},
          "save_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])},
          "add_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back"])}
        }
      }
    }
  })
}